import React from 'react';
import {reaction} from "mobx";
import {observer} from "mobx-react";
import {useEffect, useState} from "react";
import {CyClass} from "../../../../common/cy-classes";
import {useServices} from "../../../react-hooks/use-services.hook";
import {SessionTimerLabelBox} from "./boxes/session-timer-label.box";
import {SessionTimerValueBox} from "./boxes/session-timer-value.box";
import {SessionTimerBox} from "./boxes/session-timer.box";

export const SessionTimerComponent: React.FC<{className?: string}> = observer((props) => {
    const services = useServices();
    const [sessionTimer, setSessionTimer] = useState(services.sessionTimer.currentSessionTimer);

    if (!sessionTimer) {
        return null;
    }

    const hours = Math.floor(sessionTimer.totalHours);
    const minutes = Math.floor(sessionTimer.minutes);

    useEffect(() => {
        const reactionDispose = reaction(() => services.sessionTimer.currentSessionTimer,
            (currentSessionTimer) => {
                if (sessionTimer?.totalMinutes !== currentSessionTimer?.totalMinutes) {
                    setSessionTimer(currentSessionTimer);
                }
            });

        return () => {
            reactionDispose();
        }
    }, [services.sessionTimer.currentSessionTimer, sessionTimer?.totalMinutes]);

    return (
        <SessionTimerBox className={props.className}>
            {!services.device.os.isMobileOS &&
                <SessionTimerLabelBox>
                    {services.translation.translate('SESSION_TIMER_TITLE')}:
                </SessionTimerLabelBox>

            }
            <SessionTimerValueBox className={CyClass('cy-session-timer')}>
                {`${hours.toString().padStart(2, '0')} : ${minutes.toString().padStart(2, '0')}`}
            </SessionTimerValueBox>
        </SessionTimerBox>
    )
})